<template>
   <div id="layout" :class="name_class">
        <div id="header">
            <div class="search">
                <form v-on:submit.prevent="searchany()">
                    <input :class="key_search == '' ? 'active' : ''" v-model="key_search" autofocus id="searchInput" type="text" placeholder="Search...">
                    <button v-if="key_search != ''" @click="key_search = ''" type="button"><i class="fa fa-times"></i></button>
                </form>
                <div class="hambuger"  @click="openSidebar()">
                    <i class="fas fa-bars"></i>
                </div>
            </div>
        </div>
        <div class="wrapper_theme">
        
            <div :class="local == 'TRUE' ? '' : 'container'">
                <h3 class="p15">Total: {{total}}</h3>
                <div id="content" class="p15">
                {{$store.state.content}}
                </div>
                <router-view></router-view>
                <div class="row">
                    <paginate
                        :page-count="pages"
                        :click-handler="nextPage"
                        :prev-text="'<<'"
                        :next-text="'>>'"
                        :container-class="'pagination__style'"
                        :page-link-class="'page-link'"
                        :next-link-class = "'page-link'"	
                        :prev-link-class="'page-link'">
                    </paginate>
                </div>
            </div>
        </div>
        <a  id="return-to-top">
            <i class="fas fa-arrow-up"></i>
        </a>
    </div>
</template>
<script>
import {mapGetters} from 'vuex'
export default {
    data(){
        return {
            key_search: "",
            name_class: '',
           
        }
    },
    computed: {
        ...mapGetters(["pages", "total", "sidebar", "local"])
    },
   watch: {
       key_search(search)
       {
           
           this.searchany();
       },
       sidebar(newVal)
       {
           if(newVal == true)
           {
               this.name_class = ''
               this.$store.commit('close_sidebar',false)
           }
       }
   },
    methods: {
        openSidebar()
        {
            if(this.name_class == '')
            {
                this.name_class = 'open_search'
            }
            else
            {
                this.name_class = ''
            }
        },
        searchany()
        {
             this.$store.dispatch('filterData',this.key_search)
        },
        nextPage(page)
        {
            this.$store.state.loading = 'active'
            this.$store.commit("NEXT_PAGE",page);
            this.$store.state.loading = ''
        }
    },
}
</script>

<style lang="css">
.search input.active {border-radius: 25px;}
</style>